export default "__VITE_ASSET__Bil8SlIR__"